module.exports = __webpack_public_path__ + "b77a413417459a193cca3840751620d7.jpg";